import { DateFormatConstants, isNullOrUndefined } from '@uzurv/core';
import { autoserialize } from 'cerialize';
import { Moment } from 'moment';
import moment from 'moment-timezone';

export class RideVerification {
  @autoserialize
  driverFirstName: string;

  @autoserialize
  vehicleColor: string;

  @autoserialize
  vehicleYear: string;

  @autoserialize
  vehicleMake: string;

  @autoserialize
  vehicleModel: string;

  @autoserialize
  licensePlateNumber: string;

  @autoserialize
  licensePlateStateCode: string;

  @autoserialize
  riderFirstName: string;

  @autoserialize
  riderLastInitial: string;

  @autoserialize
  itineraryPickupDate: Moment;

  @autoserialize
  rideRequestPickupTime: Moment;

  @autoserialize
  timeZone: string;

  @autoserialize
  driverProfilePictureUrl: string;

  @autoserialize
  vehicleImageUrl: string;

  static OnDeserialized(instance: RideVerification, json: any): void {
    if (!isNullOrUndefined(json['itineraryPickupDate'])) {
      instance.itineraryPickupDate = moment.tz(json['itineraryPickupDate'], json['timeZone']);
    }

    if (!isNullOrUndefined(json['rideRequestPickupTime'])) {
      instance.rideRequestPickupTime = moment.tz(instance.itineraryPickupDate.format(DateFormatConstants.ISO_LOCAL_DATE) + ' ' + json['rideRequestPickupTime'], json['timeZone']);
    }
  }
}
